<div class="content content-fixed">
  <div class="container">
    <div class="mb-3 text-xl normal-case">{{ pageTitle }}</div>
    <form [formGroup]="cashCageForm" class="flex flex-wrap w-full p-4 bg-white rounded-md shadow-lg">
      <div class="grid w-full grid-cols-2 gap-1 md:grid-cols-1">
        <div class="grid grid-cols-2 gap-0.5 w-full">
          <div *ngFor="let field of rightFormFields" class="w-full px-2 mb-2">
            <label [for]="field.controlName" class="block mb-1 text-xs font-normal"> {{ field.label }}: </label>
            <input [id]="field.controlName" [formControlName]="field.controlName" [type]="field.type"
              class="w-full text-sm border border-gray-300 rounded-md px-0.5 py-0.5 focus:border-black focus:outline-none hover:border-black"
              [placeholder]="field.placeholder" [maxlength]="field.maxLength" [pattern]="field.pattern"
              (input)="validateNumberInput($event, field.controlName)"
              (paste)="preventPaste($event, field.controlName)" [ngClass]="{
                'border-red-500':
                  cashCageForm.get(field.controlName).invalid && cashCageForm.get(field.controlName).touched
              }" />
          </div>
        </div>
        <div class="grid grid-cols-2 gap-0.5 w-full">
          <div *ngFor="let field of leftFormFields" class="w-full px-2 mb-2">
            <label [for]="field.controlName" class="block mb-1 text-xs font-normal"> {{ field.label }}: </label>
            <input [id]="field.controlName" [formControlName]="field.controlName" [type]="field.type"
              class="w-full text-sm border border-gray-300 rounded-md px-0.5 py-0.5 focus:border-black focus:outline-none hover:border-black"
              [placeholder]="field.placeholder" [maxlength]="field.maxLength" [pattern]="field.pattern"
              (input)="validateNumberInput($event, field.controlName)"
              (paste)="preventPaste($event, field.controlName)" [ngClass]="{
                'border-red-500':
                  cashCageForm.get(field.controlName).invalid && cashCageForm.get(field.controlName).touched
              }" />
          </div>
        </div>
      </div>
      <div class="flex flex-wrap justify-between w-full p-2">
        <button type="button" class="px-3 py-1 text-sm border rounded-md btn btn-default" (click)="clearForm()">
          Clear Form
        </button>
        <div class="flex gap-3">
          <button type="button" class="px-3 py-1 text-sm border rounded-md btn btn-default" (click)="Documents()">
            Execute IDV Screening
          </button>
          <button type="button" class="px-3 py-1 text-sm text-white bg-blue-600 rounded-md hover:bg-blue-700"
            (click)="Screen()">
            Screen
          </button>
        </div>
      </div>
    </form>

    <!-- Verification Buttons -->
    <div class="flex justify-center w-full gap-4 mt-4">
      <button type="button" 
        class="px-4 py-2 text-white rounded-md"
        [ngClass]="getAgeVerificationClass()"
        (click)="verifyAge()">
        Age Verification
      </button>
      <button type="button" 
        class="px-4 py-2 text-white bg-purple-600 rounded-md hover:bg-purple-700"
        (click)="findSSN()"
        [disabled]="isFindingSSN">
        <span class="spinner-border mini-spinner" *ngIf="isFindingSSN"></span>
        Find SSN
      </button>
      <button type="button" 
        class="px-4 py-2 text-white rounded-md"
        [ngClass]="getSSNVerificationClass()"
        (click)="verifySSN()">
        <span class="spinner-border mini-spinner" *ngIf="isVerifyingSSN"></span>
        SSN Verification
      </button>
    </div>

    <div class="flex flex-col w-full h-auto mt-4 bg-white rounded-md" *ngIf="cashCageDetails && condents">
      <div class="flex flex-col w-full h-16 border-b-2">
        <h1 class="flex items-center w-full h-10 ml-4 text-xl font-bold ">{{cashCageDetails.firstname}} {{cashCageDetails.lastname}}</h1>
        <div class="ml-4 "></div>
      </div>
      <div class="flex w-full gap-2 p-1 pl-2">
        <ul class="nav nav-tabs">
          <li class="mr-2 nav-item" *ngFor="let item of condents">
            <a class="font-bold cursor-pointer nav-link" [ngClass]="isActiveTab(item.rule) && 'active'" (click)="tabClicked(item)">
              {{ item.rule }}
              <span [ngClass]="getStatusClass(item.status)" class="p-2 badge badge-pill">{{item.status}}</span>
            </a>
          </li>
        </ul>
      </div>
      <div *ngIf="selectionApi">
        <h1 class="mt-4 ml-2 text-xl font-bold">{{selectionApi.api}}</h1>
        <div *ngIf="selectionApi.results.length === 0" class="flex w-full pt-4 pb-12 ml-4 h-1/2">
          <h1>Clear! No matches found</h1>
        </div>
        <div *ngFor="let item of selectionApi.results" class="gap-2 m-1 ml-4">
          <div class="flex flex-wrap gap-4 w-100">
            <div
              *ngFor="let header of item.headers"
              class="flex p-2 border flex-column"
              style="flex: 1 1 50%; max-width: 49%;">
              <div class="font-bold">{{ header }}</div>
              <div class="w-auto">{{ item.contents[header] }}</div>
            </div>
          </div>
        </div>
      </div>

  </div>
  <div *ngIf="scanning" style="z-index: 1000"
    class="fixed inset-0 flex justify-center p-2 bg-black bg-opacity-25 items-top backdrop-blur-md">
    <div class="w-3/5 h-1/2 bg-[#DBD6CE] border flex flex-col items-center py-4 rounded-lg shadow-lg">
      <div class="flex justify-between w-full px-2 h-1/6">
        <h1 class="text-2xl font-bold">IDV Screening</h1>
        <p class="top-0 -mt-5 text-xl font-bold cursor-pointer" (click)="closeScanning()">✖</p>
      </div>
      <div *ngIf="!selfie" class="flex items-center justify-around w-full gap-5 py-2 bg-white h-5/6">
        <div (click)="scanningID('scan_front')"
          class="flex flex-col items-center justify-center w-1/3 gap-2 cursor-pointer h-3/5">
          <img *ngIf="!imgFront" src="../../assets/img/front-of-id-card.png" alt="Waiting Scanned Document" />
          <img *ngIf="imgFront" [src]="imgFront" alt="Scanned Document" class="w-full h-full" />
          <h1 class="text-xl font-bold">Scan front Side</h1>
        </div>
        <div (click)="scanningID('scan_back')"
          class="flex flex-col items-center justify-center w-1/3 gap-2 cursor-pointer h-3/5">
          <img *ngIf="!imgBack" src="../../assets/img/id-do-back.png" alt="Waiting Scanned Document" />
          <img *ngIf="imgBack" [src]="imgBack" alt="Scanned Document" class="w-full h-full" />
          <h1 class="text-xl font-bold">Scan back Side</h1>
        </div>
      </div>
      <div *ngIf="!selfie" class="flex items-center justify-end w-full gap-4 px-4 h-1/6">
        <button (click)="closeScanning()" class="p-2">Cancel</button>
        <button class="px-3 py-1 text-sm text-white bg-blue-600 rounded-md hover:bg-blue-700" (click)="updatesImgs()">
          IDV Screen
        </button>
      </div>
    </div>
  </div>
  <div *ngIf="isScaningLoad" style="z-index: 1001"
    class="fixed inset-0 flex flex-col items-center justify-center p-2 bg-black bg-opacity-25 backdrop-blur-md">
    <div *ngIf="isScanningSide === 'scan_front'" class="scanner_f">
      <div class="scan-line"></div>
    </div>
    <div *ngIf="isScanningSide === 'scan_back'" class="scanner_b">
      <div class="scan-line"></div>
    </div>
  </div>
  <app-spinner *ngIf="isLoading"></app-spinner>
</div>